import Autolinker from 'autolinker'

const HigherAutolinker = new Autolinker({
  newWindow: true,
  stripPrefix: false,
  phone: false,
  urls: { schemeMatches: true, wwwMatches: false, tldMatches: true },
})

export default HigherAutolinker
